import React from 'react';
import connectToStores from 'alt-utils/lib/connectToStores';
import FullScreenScorecard from './FullScreenScorecard';
import FileUploadStore from 'stores/files/FileUploadStore';
import FileUploadScorecardActions from 'actions/scorecards/FileUploadScorecardActions';
import FileUploadScorecardStore from 'stores/scorecards/FileUploadScorecardStore';
import FileUploadCallCardActions from 'actions/FileUploadCallCardActions';
import AuthStore from 'stores/AuthStore';
import CardReasonStore from 'stores/CardReasonStore';
import FileUploadCallCardStore from 'stores/files/FileUploadCallCardStore';
import ScorecardQuestionnaireStore from 'stores/scorecards/ScorecardQuestionnaireStore';
import ScorecardSchemeLabelActions from 'actions/scorecards/ScorecardSchemeLabelActions';
import ScorecardSchemeLabelStore from 'stores/scorecards/ScorecardSchemeLabelStore';
import {getQuery} from 'utils/getQueryParam';
import CardReasonActions from 'actions/CardReasonActions';

@connectToStores
export default class FullScreenScorecardContainer extends React.PureComponent {
  componentDidMount() {
    const query = getQuery(this.props.location);
    const fileUploadId = query.fileUploadId ?? this.props.fileUploadId;

    setTimeout(() => {
      FileUploadScorecardActions.fetchScorecards(fileUploadId);
      CardReasonActions.fetchReasonSchemesForCall.defer(fileUploadId);
      ScorecardSchemeLabelActions.labels();

      if (query.showReport === 'true') {
        FileUploadCallCardActions.toggleScorecardResults(true);
      } else {
        FileUploadCallCardActions.toggleScorecardResults(false);
      }
    }, 0);
  }

  static getStores() {
    return [
      AuthStore,
      ScorecardQuestionnaireStore,
      FileUploadCallCardStore,
      FileUploadStore,
      ScorecardSchemeLabelStore,
      FileUploadScorecardStore,
    ];
  }

  static getPropsFromStores(props) {
    const query = getQuery(props.location);
    const fileUploadId = query.fileUploadId ?? props.fileUploadId;
    const questionnaireState = ScorecardQuestionnaireStore.getState();
    const reasonState = CardReasonStore.getState();
    const schemeLabelState = ScorecardSchemeLabelStore.getState();
    const scorecards = FileUploadScorecardStore.getState().getIn(['scorecards', fileUploadId]);
    const {areScorecardResultsToggled} = FileUploadCallCardStore.getState();
    return {
      scorecards,
      sessionUser: AuthStore.getState().user,
      answers: questionnaireState.getIn(['answers', fileUploadId]),
      reasons: questionnaireState.getIn(['reasons', fileUploadId]),
      comments: questionnaireState.getIn(['comments', fileUploadId]),
      taggedUsers: questionnaireState.getIn(['taggedUsers', fileUploadId]),
      reasonSchemes: reasonState.get('cardReasons'),
      schemeLabels: schemeLabelState.labels,
      isSaving: questionnaireState.get('isSaving'),
      areScorecardResultsToggled,
      model: FileUploadStore.getState().fileUploads.find(fu => fu.id === fileUploadId),
    };
  }

  render() {
    const query = getQuery(this.props.location);
    const fileUploadId = query.fileUploadId ?? this.props.fileUploadId;

    return (
      <FullScreenScorecard
        {...this.props}
        modelId={fileUploadId}
        scorecardId={query.scorecardId}
        suppressWaveform={query.suppressWaveform}
        readonly={query.readonly}
      />
    );
  }
}
